@if (hasFlagPermission) {
  <button
    class="community-feed-item-report"
    [class.active]="isFlagged"
    (click)="!isFlagged && flagItem()"
    [attr.aria-label]="ariaLabel">
    <i class="material-icons flag-icon" aria-hidden="true">flag</i>
  </button>
}